import React from 'react';
import { BlockType } from '../../../lib/types';
import { HeroBlockEditor, RichTextBlockEditor, ImageBlockEditor, GalleryBlockEditor, VideoBlockEditor, MetricsBlockEditor, QuoteBlockEditor, TimelineBlockEditor, TwoColumnBlockEditor, CTABlockEditor, DividerBlockEditor, FeatureHighlightsBlockEditor, BeforeAfterBlockEditor, DesignSystemBlockEditor, WireframesBlockEditor, ResearchBlockEditor, CompetitorBlockEditor, UserFlowBlockEditor, MockupsBlockEditor, EmbedBlockEditor } from './BlockEditors';
export function getBlockEditor(type: BlockType): React.FC<{
  content: any;
  onChange: (content: any) => void;
}> {
  switch (type) {
    case 'hero':
      return HeroBlockEditor;
    case 'rich-text':
      return RichTextBlockEditor;
    case 'image':
      return ImageBlockEditor;
    case 'gallery':
      return GalleryBlockEditor;
    case 'video':
      return VideoBlockEditor;
    case 'metrics':
      return MetricsBlockEditor;
    case 'testimonial':
      return QuoteBlockEditor;
    case 'timeline':
      return TimelineBlockEditor;
    case 'two-column':
      return TwoColumnBlockEditor;
    case 'cta':
      return CTABlockEditor;
    case 'divider':
      return DividerBlockEditor;
    case 'feature-highlights':
      return FeatureHighlightsBlockEditor;
    case 'before-after':
      return BeforeAfterBlockEditor;
    case 'design-system':
      return DesignSystemBlockEditor;
    case 'wireframes':
      return WireframesBlockEditor;
    case 'research':
      return ResearchBlockEditor;
    case 'competitor':
      return CompetitorBlockEditor;
    case 'user-flow':
      return UserFlowBlockEditor;
    case 'mockups':
      return MockupsBlockEditor;
    case 'embed':
      return EmbedBlockEditor;
    default:
      return () => <div className="p-4 border border-dashed border-border text-center font-mono text-xs text-muted-foreground" data-id="element-757">
          Editor not implemented for: {type}
        </div>;
  }
}
export function getDefaultContent(type: BlockType) {
  switch (type) {
    case 'hero':
      return {
        title: '',
        subtitle: '',
        backgroundImage: '',
        overlayOpacity: 50,
        alignment: 'center',
        ctaText: '',
        ctaLink: ''
      };
    case 'rich-text':
      return {
        html: '<p>Start typing...</p>'
      };
    case 'image':
      return {
        url: '',
        alt: '',
        caption: '',
        aspectRatio: 'auto',
        objectFit: 'cover'
      };
    case 'gallery':
      return {
        images: [],
        columns: '3',
        gap: 'medium'
      };
    case 'video':
      return {
        url: '',
        embedCode: '',
        aspectRatio: '16:9',
        autoplay: false,
        loop: false
      };
    case 'metrics':
      return {
        metrics: [],
        columns: '3'
      };
    case 'testimonial':
      return {
        quote: '',
        authorName: '',
        authorRole: '',
        authorImage: '',
        variant: 'simple'
      };
    case 'timeline':
      return {
        steps: [],
        layout: 'vertical'
      };
    case 'two-column':
      return {
        leftContent: '',
        imageUrl: '',
        imageAlt: '',
        ratio: '50-50',
        reverseMobile: false
      };
    case 'cta':
      return {
        heading: '',
        description: '',
        buttonText: '',
        buttonLink: '',
        variant: 'simple'
      };
    case 'divider':
      return {
        type: 'line',
        height: 'medium'
      };
    case 'feature-highlights':
      return {
        features: [],
        columns: '3'
      };
    case 'before-after':
      return {
        beforeImage: '',
        beforeLabel: '',
        afterImage: '',
        afterLabel: '',
        layout: 'side-by-side'
      };
    case 'design-system':
      return {
        title: '',
        description: '',
        images: [],
        columns: '3'
      };
    case 'wireframes':
      return {
        title: '',
        description: '',
        images: [],
        layout: 'grid'
      };
    case 'research':
      return {
        insights: []
      };
    case 'competitor':
      return {
        competitors: []
      };
    case 'user-flow':
      return {
        title: '',
        description: '',
        imageUrl: '',
        steps: []
      };
    case 'mockups':
      return {
        title: '',
        description: '',
        images: [],
        layout: 'grid'
      };
    case 'embed':
      return {
        url: '',
        html: '',
        aspectRatio: '16:9'
      };
    default:
      return {};
  }
}